import { useState } from "react";
import { ChartSplineIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { SidebarNavElement } from "@/components/_templates/sidebar/sidebar-nav-element";
import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { makeWorkspaceUrl } from "@/domain/workspace/lib/make-workspace-url";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { useGetScenarioModelList } from "../hooks/api/use-get-scenario-model-list";

interface ScenarioSidebarNavLinkProps {
  workspace: Workspace;
}

export const ScenarioSidebarNavLink = ({ workspace }: ScenarioSidebarNavLinkProps) => {
  const { t } = useTranslation("common");
  const [hasHovered, setHasHovered] = useState(false);

  useGetScenarioModelList({
    workspaceId: workspace.id,
    enabled: hasHovered,
  });

  return (
    <FeatureFlagToggle flag={"enable-scenario-page"}>
      <SidebarNavElement
        to={makeWorkspaceUrl({ workspace: workspace, path: "scenarios" })}
        onMouseEnter={() => {
          setHasHovered(true);
        }}
      >
        <ChartSplineIcon className="mr-2 h-3 w-3" />
        {t("navigation.scenarios")}
      </SidebarNavElement>
    </FeatureFlagToggle>
  );
};
